// extracted by mini-css-extract-plugin
module.exports = {"tablaGen":"style_tablaGen__zTwjv","fila":"style_fila__3B4Dc","col":"style_col__3faAw","hiddenTable":"style_hiddenTable__2XBrE"};